import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TableVirtualScrollModule } from 'ng-table-virtual-scroll';
import { AddReportButtonComponent } from '../add-report-button/add-report-button.component';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveFileExplorerModule } from '../dave-file-explorer/dave-file-explorer.module';
import { DaveListCardModule } from '../dave-list-card/dave-list-card.module';
import { DaveListModule } from '../dave-list/dave-list.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { SelectSearchModule } from '../dave-utils-module/select-search/select-search.module';
import { LedgerImportListCardComponent } from '../ledger-import-list-card/ledger-import-list-card.component';
import { TableConfigFormComponent } from '../table-config-form/table-config-form.component';
import { WarehouseMovementComponent } from '../warehouse/warehouse-movement/warehouse-movement.component';
import { EditMaterialToSupplierDialogComponent } from './components/edit-material-to-supplier-dialog/edit-material-to-supplier-dialog.component';
import { MaterialDetailViewComponent } from './components/material-detail-view/material-detail-view.component';
import { MaterialLedgerImportListCardComponent } from './components/material-ledger-import-list-card/material-ledger-import-list-card.component';
import { MaterialMainDataPopupComponent } from './components/material-main-data-popup/material-main-data-popup.component';
import { MaterialMainDataComponent } from './components/material-main-data/material-main-data.component';
import { MaterialPriceHistoryListCardComponent } from './components/material-price-history-list-card/material-price-history-list-card.component';
import { MaterialToAmountListCardComponent } from './components/material-to-amount-list-card/material-to-amount-list-card.component';
import { MaterialToSupplierListCardComponent } from './components/material-to-supplier-list-card/material-to-supplier-list-card.component';
import { ResourceDetailViewComponent } from './components/resource-detail-view/resource-detail-view.component';
import { ResourceListComponent } from './components/resource-list/resource-list.component';
import { ResourceMainDataPopupComponent } from './components/resource-main-data-popup/resource-main-data-popup.component';
import { ResourceMainDataComponent } from './components/resource-main-data/resource-main-data.component';
import { ResourceScheduleListCardComponent } from './components/resource-schedule-list-card/resource-schedule-list-card.component';
import { SelectResourcePopupComponent } from './components/select-resource-popup/select-resource-popup.component';
import { SelectResourceComponent } from './components/select-resource/select-resource.component';
import { ResourceDispoRoutingModule } from './resource-dispo-routing.module';

@NgModule({
    declarations: [
        ResourceMainDataComponent,
        ResourceMainDataPopupComponent,
        ResourceListComponent,
        ResourceDetailViewComponent,
        ResourceScheduleListCardComponent,
        SelectResourcePopupComponent,
        SelectResourceComponent,
        MaterialMainDataComponent,
        MaterialDetailViewComponent,
        MaterialMainDataPopupComponent,
    ],
    imports: [
        CommonModule,
        ResourceDispoRoutingModule,
        DaveSharedComponentsModule,
        AppButtonModule,
        FontAwesomeModule,
        DaveLoadingModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        MatInputModule,
        MatDialogModule,
        DaveListModule,
        MatCardModule,
        DaveListCardModule,
        DaveFileExplorerModule,
        RouterModule,
        DaveDoubleIconModule,
        MatTooltipModule,
        MatChipsModule,
        ScrollingModule,
        MatTableModule,
        MatSortModule,
        TableVirtualScrollModule,
        MatCheckboxModule,
        MatListModule,
        MatSelectModule,
        AddReportButtonComponent,
        SelectSearchModule,
        LedgerImportListCardComponent,
        MatTabsModule,
        MatButtonModule,
        MatExpansionModule,
        MatIconModule,
        EditMaterialToSupplierDialogComponent,
        MaterialPriceHistoryListCardComponent,
        MaterialLedgerImportListCardComponent,
        MaterialToSupplierListCardComponent,
        MatSidenavModule,
        TableConfigFormComponent,
        MaterialToAmountListCardComponent,
        WarehouseMovementComponent,
        MatBadgeModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
    ],
    exports: [ResourceScheduleListCardComponent, SelectResourceComponent, ResourceListComponent],
})
export class ResourceDispoModule {}
